module.exports = __webpack_public_path__ + "img/banner.d11a10db.png";